export const locale = {
    lang: "es",
    data: {
        QUOTATION: {
            QUOTATION: "Cotización",
        },
    },
};
